<!-- =========================================================================================
    File Name: ItemListView.vue
    Description: Item Component - List VIew

========================================================================================== -->

<template>
    <vx-card class="list-view-item overflow-hidden w-full" v-on="$listeners" style="z-index: 0!important;">

        <template slot="no-body">
            <div class="vx-row item-details no-gutter">
              <vs-progress :percent="progress" class="block shadow-md bg-danger" color="success" v-if="progress !== 0"></vs-progress>
              <vs-progress :percent="100" class="block shadow-md" color="danger" v-else></vs-progress>

              <!-- IMG COL -->
                <div class="vx-col sm:w-1/4 w-full item-img-container bg-white flex items-center justify-center cursor-pointer" @click="navigate_to_detail_view">
                    <img :src="item.thumbnail !== null ? item.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'" :alt="item.name" class="grid-view-img p-0" style="width: 100%; height: 320px; object-fit: cover;">
                </div>

                <!-- ITEM NAME & DESC COL -->
                <div class="vx-col sm:w-1/2">
                    <div class="p-4 pt-6">
                        <slot name="item-meta">
                            <h3 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer" @click="navigate_to_detail_view">{{ item.name }}</h3>
                            <p class="item-description text-sm">{{ item.description }}</p>
                        </slot>
                    </div>
                </div>

                <!-- PURCHASE COL -->
                <div class="vx-col sm:w-1/4 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">

                    <div class="p-4 flex flex-col w-full">
                      <div class="text-white items-center justify-center border border-solid border-white flex py-2 px-2 rounded">
                        <feather-icon icon="CodesandboxIcon" svgClasses="h-4 w-4 mr-1" />
                        <span class="text-lg">{{  difficulties.find((x) => parseInt(x.id) === parseInt(item.difficulty)).name  }}</span>
                      </div>
                        <!-- SLOT: ACTION BUTTONS -->
                        <slot name="action-buttons" />
                    </div>
                </div>
            </div>
        </template>

    </vx-card>
</template>

<script>
export default{
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      difficulties: [
        {id: '0', name: 'Simple'},
        {id: '1', name: 'Easy'},
        {id: '2', name: 'Moderate'},
        {id: '3', name: 'Hard'},
        {id: '4', name: 'Challenging'}
      ],
      progress: 0
    }
  },
  computed: {
    isInWishList () {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  methods: {
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'legacy-simulation-starter', params: {simulationId: this.item.id }})
        .catch(() => {})
    }
  },
  created () {
    this.$http.get(`progress/user/specific/@me/simulation/progress?simulation=${this.item.id}`)
      .then(response => {

        this.progress = parseInt(response.data.data)

      })
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
